import { render, staticRenderFns } from "./payments-table.vue?vue&type=template&id=5f4156db&"
import script from "./payments-table.vue?vue&type=script&lang=js&"
export * from "./payments-table.vue?vue&type=script&lang=js&"
import style0 from "./payments-table.vue?vue&type=style&index=0&id=5f4156db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports